<template>
  <div class="attent">
    <user-info :userInfo="userInfo" :isShowFansBar="false" />
    <div class="content-bg">
      <h3>我的粉丝（{{ userInfo.followers_count }}）</h3>
      <van-list
        class="attent-bg"
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
        offset="30"
        :immediate-check="false"
      >
        <div
          class="attent-item"
          v-for="item in followers"
          :key="item.id"
          @click="fansClick(item.id)"
        >
          <van-image round class="attent-avatar" :src="item.headimgurl" />
          <div class="attent-user">
            <span class="attent-name">{{ item.nickname }}</span>
            <span class="attent-text">等级：{{ item.level_msg }}</span>
          </div>
          <div class="attent-fansnum">粉丝：{{ item.followers_count }}</div>
        </div>
      </van-list>
    </div>
  </div>
</template>
<script>
import UserInfo from "./child/UserInfo";
import AttentItem from "./child/AttentItem";
import CollectItem from "./child/CollectItem";
import { getUserInfo, getfollowers } from "network/profile";

export default {
  name: "Attent",
  components: {
    UserInfo,
    AttentItem,
    CollectItem,
  },
  data() {
    return {
      userInfo: {},
      currentIndex: 0,
      followers: [],
      page: 0,
      loading: false,
      finished: false,
    };
  },
  computed: {},
  created() {
    this.userInfo = JSON.parse(localStorage.getItem("userInfo"));
    this.getFollowers();
  },
  mounted() {},
  methods: {
    //点击粉丝
    fansClick(id) {
      this.$router.push({
        path: "/profileuser",
        query: {
          id,
        },
      });
    },
    //加载更多
    onLoad() {
      console.log(1111111);
      this.getFollowers();
    },
    /**
     * 请求
     */
    //粉丝列表
    getFollowers() {
      this.page++;
      getfollowers(this.userInfo.id, this.page).then((res) => {
        this.followers = this.followers.concat(res.data);
        if (res.data.length < 20 && res.data.length != 0) {
          this.loading = false;
          this.finished = true;
        } else {
          this.loading = false;
        }
      });
    },
  },
};
</script>
<style scoped>
.attent {
  background: #f5f5f5;
  min-height: 100vh;
}
.content-bg {
  margin: 20px 15px 0px 15px;
  padding: 10px;
  border-radius: 10px;
  background-color: #fff;
}
.content-bg h3 {
  font-size: 14px;
}
.attent-bg {
  margin-top: 0px;
  display: flex;
  flex-direction: column;
  align-content: space-around;
  min-height: 350px;
}
.attent-item {
  display: flex;
  align-items: center;
  padding: 15px 0;
  border-bottom: 1px solid #e5e5e5;
}
.attent-avatar {
  width: 40px;
  height: 40px;
  border: 1px solid #707070;
}
.attent-user {
  margin-left: 10px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.attent-name {
  font-size: 14px;
  color: #232323;
}
.attent-text {
  flex: 1;
  font-size: 12px;
  color: #707070;
}
.attent-fansnum {
  margin-right: 5px;
  flex: 1;
  font-size: 14px;
  color: #232323;
  text-align: right;
}
</style>